module.exports = __webpack_public_path__ + "static/img/bg-mc6.c7ee5a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg-mc6.png
// module id = gGDy
// module chunks = 1